import { IonContent, IonModal } from "@ionic/react";
import { memo, ReactNode, useRef } from "react";

interface BaseModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  children: ReactNode;
  initialBreakpoint?: number;
  breakpoints?: number[];
  backdropDismiss?: boolean;
  borderRadius?: string;
  className?: string;
  scrollY?: boolean;
  forceOverscroll?: boolean;
  handle?: boolean;
  styles?: {
    modal?: React.CSSProperties;
    content?: React.CSSProperties;
  };
}

/**
 * BaseModal - A reusable modal wrapper component
 * Wraps IonModal with common configurations
 */
export const BaseModal = memo(function BaseModal({
  isOpen,
  onDismiss,
  children,
  initialBreakpoint = 0.4,
  breakpoints = [0, 0.4, 0.6],
  backdropDismiss = true,
  borderRadius = "56px",
  className,
  scrollY,
  forceOverscroll,
  handle,
  styles,
}: BaseModalProps) {
  const modalRef = useRef<HTMLIonModalElement>(null);

  return (
    <IonModal
      ref={modalRef}
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      initialBreakpoint={initialBreakpoint}
      breakpoints={breakpoints}
      backdropDismiss={backdropDismiss}
      handle={handle}
      className={className}
      style={{ "--border-radius": borderRadius, ...styles?.modal } as React.CSSProperties}
    >
      <IonContent
        className="overflow-hidden"
        scrollY={scrollY}
        forceOverscroll={forceOverscroll}
        style={styles?.content}
      >
        {children}
      </IonContent>
    </IonModal>
  );
});
